<template>
  <div class="accessing-meter__wrapper">
    <p class="accessing-meter__title">Accessing your meters safely</p>
    <div class="accessing-meter__container">
      <template v-if="gasMeterExchange">
        <p class="accessing-meter__text">{{ gasMeterLocated.question }}</p>
        <RadioGroup
          v-model="gasMeterLocatedAnswer"
          :options="gasMeterLocatedOptions"
          data-testid="gas-meter-located"
        />
      </template>
      <template v-if="isDualFuelSite">
        <p class="accessing-meter__text">
          {{ distanceBetweenMeters.question }}
        </p>
        <RadioGroup
          v-model="distanceBetweenMetersAnswer"
          :options="distanceBetweenMetersOptions"
          data-testid="distance-between-meters"
        />
      </template>
      <p class="accessing-meter__text">
        Please select any of the following that apply to your meter(s)
      </p>
      <Checkbox
        v-model="meterAboveHeadHeightAnswer"
        :label="meterAboveHeadHeight.question"
        class="accessing-meter__checkbox"
        input-id="meterAboveHeadHeight"
        checkbox-card
        full-width
        data-testid="meter-above-head-height"
      />
      <Checkbox
        v-model="lessThanSixInchesAroundMeterAnswer"
        :label="lessThanSixInchesAroundMeter.question"
        class="accessing-meter__checkbox"
        input-id="lessThanSixInchesAroundMeter"
        checkbox-card
        full-width
        data-testid="less-than-six-inches-around-meter"
      />
      <AppButton
        class="accessing-meter__next-button"
        :disabled="!validated"
        data-testid="accessing-meter-continue-button"
        @click="nextStep"
      >
        <span> Continue </span>
        <span class="accessing-meter__icon icon icon-arrow-right" />
      </AppButton>
    </div>
  </div>
</template>

<script>
import Checkbox from "@soenergy/frontend-library/src/components/Checkbox.vue"
import AppButton from "@soenergy/frontend-library/src/components/AppButton.vue"
import { RadioGroup } from "@soenergy/frontend-library/src/components/RadioButton"
import { mapGetters } from "vuex"

export default {
  components: {
    RadioGroup,
    Checkbox,
    AppButton,
  },
  emits: ["go-forward"],
  data() {
    return {
      gasMeterLocatedOptions: [
        {
          label: "Inside my home",
          value: "Inside my home",
          inputId: "gas-meter-located-inside",
        },
        {
          label: "Outside my home",
          value: "Outside my home",
          inputId: "gas-meter-located-outside",
        },
      ],
      distanceBetweenMetersOptions: [
        {
          label: "0-5m / 0-15ft",
          value: "0-5m / 0-15ft",
          inputId: "distance-between-meters-s",
        },
        {
          label: "5-10m / 16-32ft",
          value: "5-10m / 16-32ft",
          inputId: "distance-between-meters-m",
        },
        {
          label: "Further than 10m / 32ft",
          value: "Further than 10m / 32ft",
          inputId: "distance-between-meters-l",
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      gasMeterExchange: "gasMeterExchange",
      isDualFuelSite: "isDualFuelSite",
    }),
    gasMeterLocated() {
      return this.$store.state.questionnaire["gasMeterLocation"]
    },
    distanceBetweenMeters() {
      return this.$store.state.questionnaire["distanceBetweenMeters"]
    },
    lessThanSixInchesAroundMeter() {
      return this.$store.state.questionnaire["lessThanSixInchesAroundMeter"]
    },
    meterAboveHeadHeight() {
      return this.$store.state.questionnaire["meterAboveHeadHeight"]
    },
    gasMeterLocatedAnswer: {
      get() {
        return this.gasMeterLocated.answer
      },
      set(value) {
        this.$store.commit("SET_GAS_METER_LOCATED_ANSWER", value)
      },
    },
    distanceBetweenMetersAnswer: {
      get() {
        return this.distanceBetweenMeters.answer
      },
      set(value) {
        this.$store.commit("SET_DISTANCE_BETWEEN_METERS_ANSWER", value)
      },
    },
    lessThanSixInchesAroundMeterAnswer: {
      get() {
        return this.lessThanSixInchesAroundMeter.answer
      },
      set(value) {
        this.$store.commit(
          "SET_LESS_THAN_SIX_INCHES_AROUND_METER_ANSWER",
          value
        )
      },
    },
    meterAboveHeadHeightAnswer: {
      get() {
        return this.meterAboveHeadHeight.answer
      },
      set(value) {
        this.$store.commit("SET_METER_ABOVE_HEAD_HEIGHT_ANSWER", value)
      },
    },
    validated() {
      return (
        ((this.gasMeterExchange && this.gasMeterLocatedAnswer) ||
          !this.gasMeterExchange) &&
        ((this.distanceBetweenMetersAnswer && this.isDualFuelSite) ||
          !this.isDualFuelSite)
      )
    },
  },
  methods: {
    nextStep() {
      this.$emit("go-forward")
    },
  },
}
</script>

<style lang="scss" scoped>
.accessing-meter {
  font-size: $font-size-4;
  &__wrapper {
    margin-bottom: $space-12;
    ::v-deep .form-group__input-group {
      max-width: 100%;
    }
  }
  &__icon {
    margin-left: $space-1;
  }
  &__title {
    font-size: $font-size-5;
    font-weight: $weight-medium;
    margin-bottom: $space-3;

    @include md {
      font-size: $font-size-6;
    }
  }

  &__text {
    margin-top: $space-3;
    font-size: $font-size-3;

    @include md {
      font-size: $font-size-4;
    }
  }
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__checkbox {
    margin-top: $space-2;
    margin-bottom: $space-3;
  }

  &__next-button {
    width: 100%;
    margin-top: $space-4;

    @include md {
      margin-bottom: $space-4;
    }
  }
}

::v-deep .checkbox__input:checked + .checkbox__label {
  font-weight: $weight-normal;
}
::v-deep .accordion__heading h4 {
  font-size: $font-size-5;
  font-weight: $weight-medium;
}
</style>
